
import { Field, ObjectType } from "./decorators";

@ObjectType()
export class RelatedCompany {

  @Field()
  relatedCompanyId?: number;

  @Field()
  public companyName?: string;

  @Field()
  public relatedNames?: string[];

  @Field()
  public createTime?: Date;

  @Field()
  public updateTime?: Date;

  @Field()
  public updatedBy?: string;

}

